import styled from 'styled-components';

import { TimelineCircle } from './TimelineCircle';
import { TimelineLine } from './TimelineLine';

const TimelineContainer = styled.div`
    position: absolute;
    left: -40px;
    top: 0;
    bottom: 0;
    width: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

interface ScheduleTimelineProps {
    isFirst: boolean;
    isLast: boolean;
    isCurrent: boolean;
    displayNumber: number | null;
}

export const ScheduleTimeline = ({ isFirst, isLast, isCurrent, displayNumber }: ScheduleTimelineProps) => {
    return (
        <TimelineContainer>
            <TimelineLine isFirst={isFirst} isLast={isLast} isCurrentPort={isCurrent} />
            <TimelineCircle isCurrentPort={isCurrent} displayNumber={displayNumber} />
        </TimelineContainer>
    );
};
